import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  ViewChild
} from "@angular/core";
import { LeafletService } from "../../services/leaflet.service";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "ng-leaflet-shutter",
  templateUrl: "./shutter-map.component.html",
  styleUrls: ["./shutter-map.component.css"]
})
export class ShutterMapComponent implements OnInit, AfterViewInit {
  @Input() compareLayers;
  @Input() mapOption: any;
  private shutterLayer: any;
  public shutterValue = 50;
  private map: any;
  private originClip;
  constructor(private leafletService: LeafletService) {}

  get Map() {
    return this.map;
  }

  //动态设置卷帘对比图层
  public set ShutterLayer(v: any) {
    // this.shutterLayer.getContainer().style.clip = this.originClip;
    this.map.removeLayer(this.shutterLayer);
    this.leafletService.layerControl.removeLayer(this.shutterLayer);
    this.shutterLayer = v;
  }

  getMap() {
    return this.map;
  }

  addOverlay(layer: any, layerName: string) {
    this.leafletService.addOverlay(layer, layerName);
  }

  zoomToExtent(extent: any) {
    this.map.flyToBounds(extent);
  }

  getLayerBounds(layer: any) {
    return layer.getBounds();
  }

  setCenter(latlng) {
    this.map.setView(latlng);
  }

  ngOnInit() {}

  ngAfterViewInit() {
    this.map = this.leafletService.map;

    if (this.compareLayers instanceof Array) {
      //console.log("array comparelayer:", this.compareLayers);
      this.compareLayers.forEach(item => {
        item["layer"].addTo(this.map);
        this.leafletService.addOverlay(item["layer"], item["name"]);
      });
      this.shutterLayer = this.compareLayers[1]["layer"];
      this.originClip = this.shutterLayer.getContainer().style.clip;
      this.clip();
    } else {
      (this.compareLayers as Observable<any[]>).subscribe(data => {
        // console.log("observable shutter layers：", data);
        // data.forEach(item => {
        //   item["layer"].addTo(this.map);
        //   this.leafletService.addOverlay(item["layer"], item["name"]);
        // });
        data.forEach(item => {
          if (!this.map.hasLayer(item["layer"])) {
            item["layer"].addTo(this.map);
            console.log(item["name"], "添加到图层");
            this.leafletService.addOverlay(item["layer"], item["name"]);
          }
        });
        this.shutterLayer = data[1]["layer"];
        this.clip();
      });
    }

    this.map.on("move", () => {
      const nw = this.map.containerPointToLayerPoint([0, 0]),
        se = this.map.containerPointToLayerPoint(this.map.getSize());
      // clipY = nw.y + (se.y - nw.y) * (this.shutterValue) / 100;
      // clip:rect(0px,60px,200px,0px);
      const clipX = nw.x + (se.x - nw.x) * (this.shutterValue / 100);
      const rectX = `rect(${nw.y}px ${clipX}px ${se.y}px ${nw.x}px)`;

      // const rectY = "rect(" + [nw.y, se.x, clipY, nw.x].join("px,") + "px)";
      if (this.shutterLayer) {
        this.shutterLayer.getContainer().style.clip = rectX;
      }
    });
  }
  /**
   * 卷帘
   *
   * @memberof ShutterMapComponent
   */
  shutterChange() {
    this.map.dragging.disable();
    this.clip();
  }

  afterShutter() {
    this.map.dragging.enable();
  }

  clip() {
    const nw = this.map.containerPointToLayerPoint([0, 0]),
      se = this.map.containerPointToLayerPoint(this.map.getSize());
    // clipY = nw.y + (se.y - nw.y) * (this.shutterValue) / 100;
    // clip:rect(0px,60px,200px,0px);
    const clipX = nw.x + (se.x - nw.x) * (this.shutterValue / 100);
    const rectX = `rect(${nw.y}px ${clipX}px ${se.y}px ${nw.x}px)`;

    // const rectY = "rect(" + [nw.y, se.x, clipY, nw.x].join("px,") + "px)";
    this.shutterLayer.getContainer().style.clip = rectX;
  }
}
